import { render, staticRenderFns } from "./UserMeetings.vue?vue&type=template&id=345f3e42&"
import script from "./UserMeetings.vue?vue&type=script&lang=ts&"
export * from "./UserMeetings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports